import { ArrowDown, ArrowUp } from "lucide-react";
import { ArrowDirectionEnum } from "../enums/arrow-directon.enum";
import {
  DoubleArrowConverging,
  DoubleArrowHorizontal,
} from "../arrow-drections";

const SwitchArrowDirectionIcon = ({
  arrowDirection,
  size,
}: {
  arrowDirection: ArrowDirectionEnum;
  size?: number;
}) => {
  switch (arrowDirection) {
    case ArrowDirectionEnum.UP:
      return <ArrowUp tw="h-5 w-5" />;
    case ArrowDirectionEnum.DOWN:
      return <ArrowDown tw="h-5 w-5" />;
    case ArrowDirectionEnum.OPEN:
      return <DoubleArrowHorizontal size={size} />;
    case ArrowDirectionEnum.CLOSE:
      return <DoubleArrowConverging size={size} />;
  }
};

export default SwitchArrowDirectionIcon;
